/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

import { scrollToCoord } from "../../../../framework/scripts/utils/scroll";
import JsController from '../../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'Asset Hero');
    controller.addMountFunction(() => {
        mountVerticalScrollTab(controller);
    })

    return controller.init();
}

export function mountVerticalScrollTab( controller: JsController ) {
    const verticalTabScrolls = document.querySelectorAll<HTMLElement>(`.vertical-tab-scroll`);
    const navigation = document.querySelector<HTMLElement>('.navigation');
    const navigationHeight = navigation ? navigation.clientHeight : 0;

    for(const verticalTabScroll of verticalTabScrolls) {
        const innerTabs = verticalTabScroll.querySelectorAll<HTMLElement>(`.vertical-scroll-inner-tab`);
        verticalTabScroll.querySelector<HTMLElement>(`#verticalScrollSticky`)!.style.top = `${navigationHeight + 15}px`;

        for (const innerTab of innerTabs) {
            const scroll = (event: Event) => {
                const target = event.currentTarget as HTMLElement;
                setTimeout(() => {
                    const coords = target.getBoundingClientRect().top + window.scrollY
                    scrollToCoord(coords, (navigationHeight - 2))
                }, 400);
            }

            controller.addListener(innerTab, "click", scroll)
        }
    }
}
